import React, { useState } from 'react'
import { Box, Flex, IconButton } from 'theme-ui'
import Heading from '../Typography/Heading/Heading'
import Plus from '../../../icons/Plus.svg'
import styled from '@emotion/styled'
import minus from '../../../icons/minus.svg'

const Logo = styled.img`
  width: 12px;
`

export const AccordionPanel = styled(Box)`
  width: 100%;
  overflow: hidden;
  max-height: ${props => (props.open ? '100%' : '0')};
  overflow: hidden;
  opacity: ${props => (props.open ? '1' : '0')};
  padding: ${props => (props.open ? '15px 0' : '0')};
  transition: all 0.2s ease-out;
`

const Accordion = ({
  color,
  defaultOpen,
  headingStyles,
  bodyStyles,
  ...props
}) => {
  const [hidden, setHidden] = useState(defaultOpen ? false : true)

  return (
    <Flex
      sx={{
        alignItems: 'center',
        justifyContent: 'stretch',
        flexWrap: 'wrap',
        p: 20,
      }}
      {...props}
      variant={props.v}
    >
      <Flex
        sx={{
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',

          cursor: 'pointer',
        }}
        onClick={() => setHidden(!hidden)}
      >
        <Heading
          as="h6"
          sx={{
            textTransform: 'uppercase',
            fontSize: 0,
            m: 0,
            mr: '10px',
            ...headingStyles,
          }}
        >
          {props.title}
        </Heading>
        <div>{!hidden ? <Logo src={minus} /> : <Logo src={Plus} />}</div>
      </Flex>
      <AccordionPanel open={!hidden}>{props.renderItem}</AccordionPanel>
    </Flex>
  )
}

export default Accordion
